"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteParentalPinService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var AuthSuiteParentalPinService = /** @class */ (function () {
    function AuthSuiteParentalPinService() {
        var _this = this;
        this.setParentalPin = function (parentalPin) {
            var parentalPinRoute = _this.parentalPinBaseRoute;
            var payload = { parentalPin: parentalPin };
            var body = JSON.stringify(payload);
            return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
                body: body,
                path: parentalPinRoute,
            });
        };
        this.validateParentalPin = function (parentalPin) {
            var parentalPinRoute = "".concat(_this.parentalPinBaseRoute, "/validate");
            var payload = { parentalPin: parentalPin };
            var body = JSON.stringify(payload);
            return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
                body: body,
                path: parentalPinRoute,
            });
        };
        this.deleteParentalPin = function () {
            var parentalPinRoute = _this.parentalPinBaseRoute;
            return auth_suite_fetch_1.authSuiteFetchWithAuthorization.delete({
                body: null,
                path: parentalPinRoute,
            });
        };
        this.resetParentalPin = function (parentalPin) {
            var resetParentalPinRoute = "".concat(_this.parentalPinBaseRoute, "/reset");
            var payload = { parentalPin: parentalPin };
            var body = JSON.stringify(payload);
            return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
                body: body,
                path: resetParentalPinRoute,
            });
        };
        this.getParentalPinStatus = function () {
            var parentalPinStatusRoute = "".concat(_this.parentalPinBaseRoute, "/status");
            return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
                path: parentalPinStatusRoute,
            });
        };
        this.updateParentalPinDevices = function (request) {
            var parentalPinDevicesRoute = "".concat(_this.parentalPinBaseRoute, "/devices");
            var body = JSON.stringify(request);
            return auth_suite_fetch_1.authSuiteFetchWithAuthorization.patch({
                body: body,
                path: parentalPinDevicesRoute,
            });
        };
        this.getParentalPinDevices = function () {
            var parentalPinDevicesRoute = "".concat(_this.parentalPinBaseRoute, "/devices");
            return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
                path: parentalPinDevicesRoute,
            });
        };
        this.parentalPinBaseRoute = "parentalPin";
    }
    return AuthSuiteParentalPinService;
}());
exports.AuthSuiteParentalPinService = AuthSuiteParentalPinService;
